export default "__VITE_ASSET__Cf7BiIJt__"